const segmentationFilter = (inputValue, option) => {
  const optionText = option.children.props.children[0].props.children.toLowerCase();
  const inputString = `${inputValue.toLowerCase()}`;

  return optionText.indexOf(inputString) > -1;
};

export default segmentationFilter;
